import React from 'react';
import { documentDefinition } from '../../types/Search';
import Common from '../../common/Common';

export interface Props {
    document: documentDefinition;
}
export const Description: React.FC<Props> = (props) => {
    const description = Common.generateFileName(props.document);
    let descSplit = description.split(' ');
    if (descSplit.length < 4) {
        return (
            <>
                <div>{description}</div>
            </>
        );
    }
    let descMainInfo = descSplit.splice(0, 3);
    const locationAndType = descMainInfo.join(' ');
    const otherInfo = descSplit.join(' ');
    return (
        <>
            <div className='locationInfo'>{locationAndType}</div>
            <div className='otherInfo'>{otherInfo}</div>
        </>
    );
};

export default Description;
